import React, { useEffect } from "react"
import { Grommet } from "grommet"
import { deepMerge } from "grommet/utils"
import derbyGrommetTheme from "./GrommetTheme"

// Styles
import * as styles from "./Layout.module.scss"

// Components
import SiteHeader from "./SiteHeader"
import SiteFooter from "./SiteFooter"
import SponsorsLogos from "./SponsorsLogos"

const themeObject = deepMerge(derbyGrommetTheme, {
    global: {
        spacing: "12px", // Just for range slider, but why?
        colors: {
            focus: {
                dark: "#444444",
                light: "#CCCCCC",
            },
        },
        font: {
            family: false, // Removes this declaration entirely
            size: false, // Removes this declaration entirely
            height: false, // Removes this declaration entirely
        },
        breakpoints: {
            small: false,
            medium: false,
            large: false,
            smallMobile: { value: 480 },
            mobile: { value: 767 },
            tablet: { value: 1024 },
            desktop: { value: 1680 },
            wide: { value: 10000 },
        },
        input: {
            weight: 400,
        },
    },
    rangeInput: {
        track: {
            //color: "#ff0000",
            height: "2px",
        },
        thumb: {
            //color: "#ff0000"
        },
    },
})

const Layout = (props) => {
    useEffect(() => {
        if (typeof window !== "undefined") {
            function handleFirstTab(e) {
                if (e.keyCode === 9) {
                    document.body.classList.add("user-is-tabbing")
                    window.removeEventListener("keydown", handleFirstTab)
                }
            }

            return () => {
                window.removeEventListener("keydown", handleFirstTab)
            }
        }
    })

    return (
        <Grommet full theme={themeObject} className={styles.Grommet}>
            <div className={`${styles.Layout} ${props.venue.theme} ${props.currentTemplate}`}>

                <SiteHeader venue={props.venue} currentLocation={props.currentLocation} />
                {props.children}
                <SponsorsLogos />
                <SiteFooter />
            </div>
        </Grommet>
    )
}

export default Layout
